import { useMemo } from "react";

import { CloudflowEngine } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useCollectionData } from "@doitintl/models-hooks";

import { useCustomerId } from "../../../../../../Components/hooks/useCustomerId";
import { getCachingKeys } from "../../../../../../utils/cachingKeys";

export const useSystemEvents = () => {
  const customerId = useCustomerId();

  const query = useMemo(
    () => getCollection(CloudflowEngine).doc("triggers").collection("sources").doc("systemEvents").collection("events"),
    []
  );

  return useCollectionData(query, {
    caching: true,
    cachingKeys: getCachingKeys(customerId),
    idField: "id",
  });
};
